import EntityInfo from "../types/EntityInfo";

export const otherProducts: EntityInfo[] = [
    {id: 1, name: 'Nutrlac'},
    {id: 2, name: 'Similac'},
    {id: 3, name: 'Hipp'},
    {id: 4, name: 'Humana'},
    {id: 5, name: 'Danalac'},
    {id: 6, name: 'Kabrita'},
    {id: 7, name: 'Digər'},
    {id: 8, name: 'Nan'},
    { id: 9, name: "Nutrilon" },
    { id: 10, name: "Bebelac" },
    { id: 11, name: "Malutka" },
    { id: 12, name: "Nestogen" },
    { id: 13, name: "Malyuk" },
    { id: 14, name: "Bebevit" },
    { id: 15, name: "Nutrilak" },
    { id: 16, name: "Nenni" },
    { id: 17, name: "Aptamil" },
    { id: 18, name: "Swissneo" },
    { id: 19, name: "Mamako" },
    { id: 20, name: "Nutriben" },
    { id: 21, name: "Sahha" }
]